module.exports = __webpack_public_path__ + "img/chevron-up.79d7e9b1.svg";